module.exports = __webpack_public_path__ + "statics/img/xinli_adv.88ebcdfe.jpg";